import { createContext, Dispatch, useContext } from "react";
import { Graph_QL } from "../../../Services";
import { ReportData, ReportTemplate } from "../../../Definitions";

export enum ReportModalTypes {
  createReport = "createReport",
  createTemplate = "createTemplate",
  copyTemplate = "copyTemplate"
}

/* eslint-disable */
enum IReportContextEnum {
  currentViewLevel = "currentViewLevel",
  currentViewType = "currentViewType",
  report = "report",
  template = "template"
}
/* eslint-enable */

export type IReportContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;
  currentViewLevel: number;
  currentViewType: ReportModalTypes | undefined;
  report: ReportData;
  template: ReportTemplate;
  error: { Elementid: number, errorText: string };
  reset: any
};

export type ReportDispatcherT = Deep_Partial<IReportContext>;

type ReportContexter = {
  state: IReportContext,
  dispatch: Dispatch<ReportDispatcherT>
}

export const ReportContext = createContext<ReportContexter | undefined>(undefined);

export function ReportReducer(state: IReportContext, action: ReportDispatcherT) {
  let ResultState = state;
  
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case IReportContextEnum.currentViewLevel:
        ResultState = Object.assign({}, ResultState, {
          currentViewLevel: payload
        } as ReportDispatcherT)
        break;
        case IReportContextEnum.currentViewType:
          ResultState = Object.assign({}, ResultState, {
            currentViewType: payload
          } as ReportDispatcherT)
        break;
      case IReportContextEnum.report:
        let newRport_State = Object.assign({}, ResultState.report, payload)
        ResultState = Object.assign({}, ResultState, {
          report: newRport_State
        } as ReportDispatcherT)
        break;
        case IReportContextEnum.template:
          let newTemplate_State = Object.assign({}, ResultState.template, payload)
          ResultState = Object.assign({}, ResultState, {
            [IReportContextEnum.template]: newTemplate_State
          } as ReportDispatcherT)
        break;
      case "error":
        ResultState = { ...ResultState, error: payload as IReportContext["error"] };
        break;
        case "reset":
          ResultState = {
            ...ResultState,
            currentViewLevel: 1,
            currentViewType: undefined,
            report: {
              name: undefined,
              startDate: undefined,
              endDate: undefined,
              dataLevel: undefined,
              filterParameter: [[]]
            },
            template: {
              name: undefined,
              dataLevel: undefined,
              filterParameter: [[]],
            },
            error: { Elementid: 0, errorText: "" }
          };
          break;
  
      default:
        console.error(`Unhandled action type: ${type}`)
      break
    }
  })
  return ResultState;
}

export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error("useReportContext must be used within a ReportProvider");
  }
  return context;
};